<ng-container *ngIf="readyIn">
    <button [disabled]="loading" (click)="pay()" title="payer la commande" placement="bottom" class="btn btn-success">
        <ng-container *ngIf="loading">
            <i class='glyphicon glyphicon-refresh spinning'></i>
            &nbsp;&nbsp;
        </ng-container>
        Payer la commande
    </button>
    <br>
    <span class="badge badge-warning">
        Expire dans {{readyIn}} Min
    </span>
</ng-container>
<ng-container *ngIf="!readyIn">
    <span class="badge badge-info">
        Expirée
    </span>
</ng-container>